// extracted by mini-css-extract-plugin
export default {"sectionTitle":"nXIodyg1","remove":"dChRb5ot","sectionTitleWrapper":"T4SHtBcl","requiredIndicator":"BsUpxN1x","mainFormSectionContent":"ydp02SS0","border":"GrlNtFmm"};